module.exports = __webpack_public_path__ + "img/poeple_Artboard.8e70262b.png";